/* global google */
import "./App.css";
import React, { useEffect, useState } from "react";

function App() {
  // States to handle form status
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  useEffect(() => {
    let contentString;

    async function initMap() {
      const { Place } = await google.maps.importLibrary("places");

      // Use place ID to create a new Place instance.
      const place = new Place({
        id: "ChIJoeU307ooRSgRLieUOjbbkmU", // Faneuil Hall Marketplace, Boston, MA
      });

      // Call fetchFields, passing 'reviews' and other needed fields.
      await place.fetchFields({
        fields: ["displayName", "formattedAddress", "location", "reviews"],
      });
      // If there are any reviews display the first one.
      if (place.reviews && place.reviews.length > 0) {
        // Get info for the first review.
        let reviewRating = place.reviews[0].rating;
        let reviewText = place.reviews[0].text;
        let authorName = place.reviews[0].authorAttribution.displayName;
        let authorUri = place.reviews[0].authorAttribution.uri;

        // Format the review using HTML.
        contentString = `
            Title: ${place.displayName}\n
            Address: ${place.formattedAddress}\n
            ${authorUri}"\n
            Author: ${authorName}\n
            Rating: ${reviewRating}\n
            Review: ${reviewText}`;

        console.log(contentString);
      } else {
        contentString = "No reviews were found for " + place.displayName + ".";
      }
    }

    initMap();
  }, []);

  // Handler for background form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("loading");

    const formData = new FormData(e.target);

    fetch(
      "https://docs.google.com/forms/u/0/d/e/1FAIpQLSf9n9Xm7Psgecvf7jtLg8vPkLsUZY64QwD8G3HM3nWKPZHSog/formResponse",
      {
        method: "POST",
        body: formData,
        mode: "no-cors", // Essential to bypass CORS blocks on external sub
      },
    )
      .then(() => {
        setStatus("success");
        e.target.reset(); // Clear form fields
      })
      .catch((error) => {
        console.error("Submission error:", error);
        setStatus("error");
      });
  };

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className="bg-white shadow-md py-2">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <a
            href="/"
            className="text-2xl font-bold text-blue-500 flex justify-between items-center"
          >
            <img
              src="TMM256.png"
              alt="Hand with question mark"
              className="h-12 pr-4 transform transition-transform duration-200 hover:scale-110"
            />
            TutorMeMudit
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="bg-blue-500 text-white py-20 px-4 text-center">
        <p className="text-5xl font-bold cursive pb-4">
          Turn your struggle into strength - one session at a time
        </p>
        <h1 className="mt-4 text-xl">
          High School Math & Physics Tutor in Toronto
        </h1>
        <a
          href="#contact"
          className="mt-8 inline-block bg-white text-blue-500 font-semibold py-3 px-6 rounded-lg shadow-lg hover:bg-gray-100 transform transition-transform duration-200 hover:scale-105"
          aria-label="Book free trial session"
        >
          Book your free trial now!
        </a>
      </header>

      {/* What's offered Section */}
      <section id="offered" className="py-20 bg-gray-200 text-center">
        <div className="container mx-auto px-2 flex flex-col items-center">
          <h2 className="text-5xl font-bold mb-8 cursive">What's Offered</h2>
          <div className="w-full md:w-3/4 flex flex-wrap justify-center items-stretch">
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Math Tutoring</h3>
              </div>
            </div>
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Physics Tutoring</h3>
              </div>
            </div>
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Exam Prep</h3>
              </div>
            </div>
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Homework Help</h3>
              </div>
            </div>
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Concept Deep Dive</h3>
              </div>
            </div>
            <div className="w-3/4 md:w-1/3 p-5">
              <div className="flex flex-col h-full bg-white p-4 rounded-lg shadow-lg">
                <h3 className="text-xl">Summer Catch-Up</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What To Expect Section */}
      <section id="expected" className="py-20 bg-gray-100 text-center">
        <div className="container mx-auto px-2">
          <h2 className="text-5xl font-bold mb-8 cursive">What To Expect</h2>
          <div className="flex justify-center">
            <ul className="md:text-xl text-left list-none space-y-4 max-w-3xl">
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                Sessions are personalized — typically a mix of clear concept
                explanations and guided problem-solving (homework help or
                curriculum-aligned practice), depending on each student's needs.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                Most students have a fixed{" "}
                <strong>weekly 1-hour session</strong> at the same time each
                week to ensure consistent progress.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                My rates typically start at <strong>$75/hour</strong> — but I'm
                flexible depending on individual situations.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                I keep parents closely informed with regular feedback on
                progress, strengths, and areas to work on.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                I offer a <strong>free trial session</strong> so you can
                experience my teaching style before committing.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                Sessions are available <strong>online</strong> and{" "}
                <strong>in-person</strong>.
              </li>
              <li className="relative pl-6 before:content-['→'] before:absolute before:left-0 before:text-blue-500">
                In-person sessions are available in the{" "}
                <strong>North Toronto area </strong>
                (Forest Hill North, Lawrence Manor, and surrounding
                neighborhoods).
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gray-200 text-center">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold mb-8 cursive">
            About TutorMeMudit
          </h2>
          <p className="md:text-xl text-gray-900 leading-relaxed max-w-3xl mx-auto">
            I’m Mudit, a passionate Math and Physics tutor with several years of
            experience helping high school students across Toronto build
            confidence and excel. I originally began tutoring through online
            platforms and local agencies — but over time, I saw how high
            middleman fees were inflating costs for families and limiting access
            for students who needed support.
          </p>
          <br />
          <p className="md:text-xl text-gray-900 leading-relaxed max-w-3xl mx-auto">
            To change that, I created TutorMeMudit as an independent service —
            offering direct, personalized tutoring without the added platform
            fees. This allows me to build strong relationships with students and
            tailor each session to their individual needs and learning styles,
            while keeping rates more affordable for families.
          </p>
          <br />
          <p className="md:text-xl text-gray-900 leading-relaxed max-w-3xl mx-auto">
            Today, I work with students from a wide range of Toronto schools —
            including Earl Haig Secondary School, Upper Canada College (UCC),
            Northern Secondary School, and more. Whether a student is striving
            for top grades or looking to strengthen their understanding and
            confidence, TutorMeMudit provides the personalized support they need
            to succeed.
          </p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 bg-gray-100 text-center">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold mb-8 cursive">Testimonials</h2>
          <div className="md:text-xl flex flex-wrap justify-center items-stretch">
            <div className="md:w-1/3 min-w-96 p-5 flex flex-col">
              <div className="h-full bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <p className="text-gray-900 leading-relaxed">
                  "I am pleased to let you know my daughter did a great job on
                  her math test today and received a mark of 11% more than her
                  last test! The teacher and we are very proud of this result.
                  Clearly yesterday's tutoring session had an impact."
                </p>
                <h3 className="text-l font-bold mt-4">
                  -Parent of Grade 9 Math student at Toronto Prep School
                </h3>
              </div>
            </div>
            <div className="md:w-1/3 min-w-96 p-5 flex flex-col">
              <div className="h-full bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <p className="text-gray-900 leading-relaxed">
                  "I wanted to thank you again for all your work with my son.
                  Not only did he get 91 on the final exam, but it was also the
                  highest mark in the class! All thanks to your support. His
                  teacher was even impressed. We really appreciate all your
                  efforts. Thank you."
                </p>
                <h3 className="text-l font-bold mt-4">
                  -Parent of Grade 12 Physics student at Lawrence Park CI
                </h3>
              </div>
            </div>
            <div className="md:w-1/3 min-w-96 p-5 flex flex-col">
              <div className="h-full bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <p className="text-gray-900 leading-relaxed">
                  "Thank you very much Mudit for all your help and encouraging
                  and positive messages ! I have seen my son's confidence and
                  marks go up :) I just read him your email as he prepares to
                  write his math exam in a few hours. All the best to you and
                  thank you again !!"
                </p>
                <h3 className="text-l font-bold mt-4">
                  -Parent of Grade 10 Math student at Earl Haig SS
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-200 text-center">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl font-bold mb-8 cursive">Contact</h2>
          <p className="md:text-xl mb-8">
            <strong>Email:</strong>{" "}
            <a href="mailto:tutormemudit@gmail.com">tutormemudit@gmail.com</a>
            <br />
            <br />
            <strong>Phone:</strong>
            <a href="tel:+16478776926">+1 (647) 877-6926</a>
            <br />
            <br />
            Or drop a message right here{" "}
            <span className="inline-block animate-bounce">↓</span>
          </p>

          <form
            onSubmit={handleSubmit}
            className="max-w-lg mx-auto bg-white p-8 rounded-lg shadow-lg"
          >
            <div className="mb-4 flex items-center text-left">
              <label
                htmlFor="name"
                className="md:text-xl block text-gray-700 font-bold w-24"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="entry.881806240"
                required
                className="flex-1 px-2 py-2 border rounded-lg focus:outline-none focus:border-blue-500 w-3/4"
              />
            </div>
            <div className="mb-4 flex items-center text-left">
              <label
                htmlFor="email"
                className="md:text-xl block text-gray-700 font-bold w-24"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="entry.1045256218"
                required
                className="flex-1 px-2 py-2 border rounded-lg focus:outline-none focus:border-blue-500 w-3/4"
              />
            </div>
            <div className="mb-4 flex items-center">
              <label
                htmlFor="message"
                className="md:text-xl block text-gray-700 font-bold w-24 text-left"
              >
                Message
              </label>
              <textarea
                rows="4"
                id="message"
                name="entry.781043323"
                required
                className="flex-1 px-2 py-2 border rounded-lg focus:outline-none focus:border-blue-500 w-3/4"
              ></textarea>
            </div>

            <div className="flex flex-col items-end">
              <button
                type="submit"
                disabled={status === "loading"}
                className="w-1/2 bg-blue-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-blue-600 transition transform duration-200 hover:scale-105 disabled:bg-blue-300"
              >
                {status === "loading" ? "Sending..." : "Send Message"}
              </button>

              {/* Status Notifications */}
              {status === "success" && (
                <p className="text-green-600 font-bold mt-4 text-center w-full">
                  ✓ Thank you! I've received your message and will get back to
                  you shortly.
                </p>
              )}
              {status === "error" && (
                <p className="text-red-600 font-bold mt-4 text-center w-full">
                  ✕ Something went wrong. Please try again or call directly.
                </p>
              )}
            </div>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-4">
        <div className="container mx-auto px-4 text-center text-gray-700">
          &copy; {new Date().getFullYear()} TutorMeMudit. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
